import { Component, OnInit } from '@angular/core';
import { EndorsementService } from 'src/app/partner-portal/services/endorsement.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PolicyConstant } from 'src/app/partner-portal/Model/policyConstant';
import { ProposalService } from 'src/app/partner-portal/services/proposal.service';
import { MotorService } from 'src/app/partner-portal/services/motor.service';
import { QuoteService } from 'src/app/partner-portal/services/quote.service';

@Component({
    selector: 'app-endorsement-customer-view',
    templateUrl: './endorsement-customer-view.component.html',
    styleUrls: ['./endorsement-customer-view.component.css'],
    standalone: false
})
export class EndorsementCustomerViewComponent implements OnInit {

  public customerData: any
  public data: any;
  public financierDetail: any;
  public nomineeDetail: any;
  public policyDetail: any;

  responseData: any;
  policyStartDate: Date;
  policyEndDate: Date
  safeHTML: SafeHtml;
  panelOpenState: boolean = true;
  isCheckedAddon: number | null = 0;
  proposalNumber: any
  tempEndorsementNumber: string;
  isDeclarationAccepted: boolean = true;
  status: any;
  isCustomerProposalMakePaymentSuccess: boolean = false;
  public policyConstant = PolicyConstant;
  endorsementDetails: any;
  isPremiumCalculated: boolean = false;
  isPremiumVisibility: boolean = false;
  defaultShow: boolean = false;

  constructor(public endorsementService: EndorsementService, private route: ActivatedRoute, private notificationService: NotificationService, private domSanitizer: DomSanitizer, private proposalService: ProposalService, private motorService: MotorService, private quoteService: QuoteService) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if ('endorsementNo' in params) {
        this.tempEndorsementNumber = params.endorsementNo;
      }
      if ('status' in params) {
        this.status = params.status;
        if (this.status === 'success') {
          this.isCustomerProposalMakePaymentSuccess = true;
        }
      }
    })
    const BASE_64_STR = this.tempEndorsementNumber?.substring(5) || '';
    const DECODED_STR = CryptoJS.enc.Base64.parse(BASE_64_STR) || '';
    this.tempEndorsementNumber = CryptoJS.enc.Utf8.stringify(DECODED_STR)?.replace('[', '')?.replace(']', '')?.trim() || this.tempEndorsementNumber;
    //this.tempEndorsementNumber = 'EN31551505251131003963';
    this.initializeForms();
    this.endorsementService.endorsementDataForCustomerPyament(this.tempEndorsementNumber).subscribe(res => {
      if (res.status === 200) {
        this.responseData = res.result;
        this.endorsementService._enCode = res?.result?.enCode;
        this.endorsementDetails = this.getEndorsementDetails(this.responseData);
        if (this.responseData.enCode === PolicyConstant.TransferofInsurance_Code || this.responseData.enCode === PolicyConstant.NoclaimBonus_Code) {
          this.isPremiumCalculated = true;
          this.isPremiumVisibility = true;
        }
        else {
          this.isPremiumCalculated = false;
          this.isPremiumVisibility = false;
        }
        this.defaultShow = true;

      }
      else {
        this.notificationService.showError('', res.message);
      }
    });

  }

  public async makePayment(): Promise<void> {
    if (!this.isDeclarationAccepted) {
      this.notificationService.showError('Please accept the declaration to proceed with payment.', '');
      return;
    }
    this.proposalService.proposalNo = this.tempEndorsementNumber;
    this.proposalService.paymentDetailsForm.patchValue({
      paymentBy: "Customer",//hardcode
      amount: this.responseData?.endorsementTotalPremium,
      paymentDueDate: new Date(),
      paymentMode: PolicyConstant.Endorsement_Payment_link
    });
    this.proposalService.customerDetailsForm.patchValue({
      firstName: this.endorsementDetails?.firstName,
      email: this.endorsementDetails?.emailId,
      mobileNo: this.endorsementDetails?.mobileNo
    });

    let paymentLogic = await this.proposalService.getPaymentPGTypeCheck();

    if (paymentLogic.udf1 === "0") {
      let paymentHTML = await this.proposalService.getGatewayPayU(PolicyConstant.motorEndorsement);
      this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(paymentHTML);
      const myWindow = window.open('', '_self');
      myWindow.document.write(paymentHTML);
    } else {
      let paymentHTML = await this.proposalService.getGatewayPayU(PolicyConstant.Motor);
      paymentHTML = JSON.parse(paymentHTML);
      if (paymentHTML?.status !== '200') {
        this.notificationService.showError('Failed to get Payment Window!', 'Failed!');
        return null;
      } else {
        const myWindow = window.open(paymentHTML?.redirectUrl, '_self');

      }
    }
  }

  isChecked(i) {
    return this.isCheckedAddon == i;
  }

  initializeForms() {
    this.proposalService.paymentDetailsForm = this.proposalService.getPaymentDetailsForm();
    this.proposalService.customerDetailsForm = this.proposalService.getCustomerKYCDetailsForm();
  }

  downloadPdf() {
    const PAYLOAD = {
      "proposalNumber": this.tempEndorsementNumber,
      "reportNameProposal": "Proposal_Package",
      "reportNamePolicy": "PolicySchedule_Package"
    }
    switch (this.responseData?.gcProductCode?.toString()) {
      case "2011":
        PAYLOAD.reportNameProposal = "Proposal_Package";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Package";
        break;
      case "2012":
        PAYLOAD.reportNameProposal = "Proposal_Package";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Package";
        break;
      case "2013":
      case "2014":
        PAYLOAD.reportNameProposal = "Proposal_Package";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Package";
        break;
      case "2015":
        PAYLOAD.reportNameProposal = "Proposal_Liability";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Liability";
        break;
      case "2016":
        PAYLOAD.reportNameProposal = "Proposal_Liability";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Liability";
        break;
      case "2017":
      case "2018":
        PAYLOAD.reportNameProposal = "Proposal_Liability";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Liability";
        break;
      case "2019":
        PAYLOAD.reportNameProposal = "CPA_Proposal";
        PAYLOAD.reportNamePolicy = "CPA_Schedule";
        break;
      case "2025":
        PAYLOAD.reportNameProposal = "Proposal_ODOnly";
        PAYLOAD.reportNamePolicy = "PolicySchedule_OD_Only";
        break;
      case "2026":
        PAYLOAD.reportNameProposal = "Proposal_ODOnly";
        PAYLOAD.reportNamePolicy = "PolicySchedule_OD_Only";
        break;
      default:
        break;
    }
    this.quoteService.downloadPolicyPdf(PAYLOAD).subscribe(blob => {
      this.motorService.downloadPdf(blob, this.tempEndorsementNumber);
    });
  }

  getEndorsementDetails(data) {
    let endorsementDetails = {};

    if (data?.enCode === this.policyConstant.CustomerDetailsInsuredName_Code) {
      endorsementDetails = {
        firstName: data?.changedData[0]?.newValue,
        lastName: data?.changedData[1]?.newValue,
      };
    }
    else if (data?.enCode === this.policyConstant.EngineChassisInterchange_Code || data?.enCode === this.policyConstant.EngineChassisMaxTwoDigits_Code) {
      endorsementDetails = {
        engineNumber: data?.changedData[0]?.newValue,
        chassisNumber: data?.changedData[1]?.newValue,
      };
    } else if (data?.enCode === this.policyConstant.CustomerDetailsCommunicationAddress_Code) {
      endorsementDetails = {
        newAddress1: data?.changedData.find(
          (item) => item.fieldName === 'address1'
        )?.newValue,
        newAddress2: data?.changedData.find(
          (item) => item.fieldName === 'address2'
        )?.newValue,
        newCity: data?.changedData.find((item) => item.fieldName === 'city')
          ?.newValue,
        newState: data?.changedData.find((item) => item.fieldName === 'state')
          ?.newValue,
        newPincode: data?.changedData.find(
          (item) => item.fieldName === 'pincode'
        )?.newValue,
        newEmailId: data?.changedData.find(
          (item) => item.fieldName === 'emailId'
        )?.newValue,
        newMobileNumber: data?.changedData.find(
          (item) => item.fieldName === 'mobileNo'
        )?.newValue,
      };
    } else if (data?.enCode === this.policyConstant.FinancierDetailsAmendment_Code || data?.enCode === this.policyConstant.FinancierDetailsIncorporation_Code || data?.enCode === this.policyConstant.FinancierDetailsDeletion_Code) {
      endorsementDetails = {
        newFinancierName: data?.changedData.find(
          (item) => item.fieldName === 'financierName'
        )?.newValue,
        newFinancierAddress: data?.changedData.find(
          (item) => item.fieldName === 'financierAddress'
        )?.newValue,
        newFinancierType: data?.changedData.find(
          (item) => item.fieldName === 'financierType'
        )?.newValue,
      };
    } else if (data?.enCode === this.policyConstant.NomineeDetails_Code) {
      endorsementDetails = {
        newFirstName: data?.changedData.find(
          (item) => item.fieldName === 'nomineeFirstName'
        )?.newValue,
        newMiddleName: data?.changedData.find(
          (item) => item.fieldName === 'nomineeMiddleName'
        )?.newValue,
        newLastName: data?.changedData.find(
          (item) => item.fieldName === 'nomineeLastName'
        )?.newValue,
        newRelationship: data?.changedData.find(
          (item) => item.fieldName === 'nomineeRelationShip'
        )?.newValue,
        newIsMinor: data?.changedData.find((item) => item.fieldName === 'isMinor')?.newValue == 'yes'
          ? 'yes' : 'no',
        newRepresentativeFirstName: data?.changedData.find(
          (item) => item.fieldName === 'representativeFirstName'
        )?.newValue,
        newRepresentativeMiddleName: data?.changedData.find(
          (item) => item.fieldName === 'representativeMiddleName'
        )?.newValue,
        newRepresentativeLastName: data?.changedData.find(
          (item) => item.fieldName === 'representativeLastName'
        )?.newValue,
        newRelationshipWithMinor: data?.changedData.find(
          (item) => item.fieldName === 'representativeRelationShip'
        )?.newValue,
        newOtherRelationship: data?.changedData.find(
          (item) => item.fieldName === 'otherRelationShip'
        )?.newValue,
        newOtherRepresentativeRelationShip: data?.changedData.find(
          (item) => item.fieldName === 'otherRepresentativeRelationShip'
        )?.newValue,
      };
    } else if (this.endorsementService._enCode === this.policyConstant.TransferofInsurance_Code) {
      endorsementDetails = {
        firstName: data?.changedData.find((item) => item.fieldName === 'firstName')?.newValue,
        lastName: data?.changedData.find((item) => item.fieldName === 'lastName')?.newValue,
        panNumber: data?.changedData.find((item) => item.fieldName === 'panNumber')?.newValue,
        ckycAadharNumber: data?.changedData.find((item) => item.fieldName === 'ckycAadharNumber')?.newValue,
        ckycNumber: data?.changedData.find((item) => item.fieldName === 'ckycNumber')?.newValue,
        dateOfBirth: data?.changedData.find((item) => item.fieldName === 'dateOfBirth')?.newValue,
        gender: data?.changedData.find((item) => item.fieldName === 'gender')?.newValue,
        emailId: data?.changedData.find((item) => item.fieldName === 'emailId')?.newValue,
        mobileNo: data?.changedData.find((item) => item.fieldName === 'mobileNo')?.newValue,
        mailingAddress: data?.changedData.find((item) => item.fieldName === 'mailingAddress')?.newValue,
        mailingPinCode: data?.changedData.find((item) => item.fieldName === 'mailingPinCode')?.newValue,
        mailingTownOrCity: data?.changedData.find((item) => item.fieldName === 'mailingTownOrCity')?.newValue,
        mailingAreaOrLocality: data?.changedData.find((item) => item.fieldName === 'mailingAreaOrLocality')?.newValue,
        stateCode: data?.changedData.find((item) => item.fieldName === 'mailingStateCd')?.newValue,
        state: data?.changedData.find((item) => item.fieldName === 'mailingState')?.newValue,
        districtCode: data?.changedData.find((item) => item.fieldName === 'mailingDistrictCd')?.newValue,
        district: data?.changedData.find((item) => item.fieldName === 'mailingDistrict')?.newValue,
        salutation: data?.changedData.find((item) => item.fieldName === 'salutation')?.newValue,
        financierName: data?.changedData.find((item) => item.fieldName === 'financierName')?.newValue,
        fianncierAddress: data?.changedData.find((item) => item.fieldName === 'financierAddress')?.newValue,
        AggrementType: data?.changedData.find((item) => item.fieldName === 'AgreementType')?.newValue,
        nomineeFirstName: data?.changedData.find((item) => item.fieldName === 'nomineeFirstName')?.newValue,
        nomineeMiddleName: data?.changedData.find((item) => item.fieldName === 'nomineeMiddleName')?.newValue,
        nomineeLastName: data?.changedData.find((item) => item.fieldName === 'nomineeLastName')?.newValue,
        nomineeIsMinor: ['true', 'yes'].includes(data?.changedData.find((item) => item.fieldName === 'nomineeIsMinor')?.newValue?.toLowerCase()) ? 'yes' : ['false', 'no'].includes(data?.changedData.find((item) => item.fieldName === 'nomineeIsMinor')?.newValue?.toLowerCase()) ? 'no' : '',
        otherRelationship: data?.changedData.find((item) => item.fieldName === 'otherRelationship')?.newValue,
        representativeFirstName: data?.changedData.find((item) => item.fieldName === 'representativeFirstName')?.newValue,
        representativeMiddleName: data?.changedData.find((item) => item.fieldName === 'representativeMiddleName')?.newValue,
        representativeLastName: data?.changedData.find((item) => item.fieldName === 'representativeLastName')?.newValue,
        relationshipWiththeMinor: data?.changedData.find((item) => item.fieldName === 'relationshipWiththeMinor')?.newValue,
        otherRepresentativeRelationship: data?.changedData.find((item) => item.fieldName === 'otherRepresentativeRelationship')?.newValue,
        relationshipWiththeInsured: data?.changedData.find((item) => item.fieldName === 'relationshipWiththeInsured')?.newValue,
        discountAmount: data?.changedData.find((item) => item.fieldName === 'discountAmount')?.newValue,
        discountRate: data?.changedData.find((item) => item.fieldName === 'discountRate')?.newValue,
      };
    } else if (data?.enCode === this.policyConstant?.NoclaimBonus_Code) {
      endorsementDetails = {
        IsPreviousClaim: data?.changedData.find(
          (item) => item.fieldName === 'IsPreviousClaim'
        )?.newValue
          ? data?.changedData.find(
            (item) => item.fieldName === 'IsPreviousClaim'
          )?.newValue
          : '-',
        NCBasperpolicy: data?.changedData.find(
          (item) => item.fieldName === 'ncbAsPerPolicy'
        )?.newValue
          ? data?.changedData.find(
            (item) => item.fieldName === 'ncbAsPerPolicy'
          )?.newValue
          : '-',
      };
      //console.log(endorsementDetails, 'endorsementDetails');
    } else if (this.endorsementService._enCode === this.policyConstant?.ZoneReRegistration_Code) {
      endorsementDetails = {
        Zone: data?.changedData.find((item) => item.fieldName === 'rtoCodeAndZone')?.newValue,
        isBhSeries: data?.changedData.find((item) => item.fieldName === 'propRisksExtraBoolean14')?.newValue === "True" ? true : false,
        RegsistartionNo1: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.newValue,
        RegsistartionNo2: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.newValue,
        RegsistartionNo3: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.newValue,
        RegsistartionNo4: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.newValue,
        RegistrationNo: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.newValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.newValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.newValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.newValue
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.CorrectionofRegistrationNo_Code) {
      endorsementDetails = {
        Zone: data?.changedData.find((item) => item.fieldName === 'propRisksRtoCode')?.newValue,
        isBhSeries: data?.changedData.find((item) => item.fieldName === 'propRisksExtraBoolean14')?.newValue === "True" ? true : false,
        RegsistartionNo1: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.newValue,
        RegsistartionNo2: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.newValue,
        RegsistartionNo3: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.newValue,
        RegsistartionNo4: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.newValue,
        RegistrationNo: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.newValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.newValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.newValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.newValue
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.InclusionofIMT_Code) {
      endorsementDetails = {
        newImt23Coverage: data?.changedData.find((item) => item.fieldName === 'propRisksCoverForLampTyres')?.newValue === "True" ? true : false,
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.InclusionofIMTcoverage_Code) {
      endorsementDetails = {
        newImt47Coverage: data?.changedData.find((item) => item.fieldName === 'propRisksIsVehiUsAsAToOfTra')?.newValue === "True" ? true : false,
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.changeofEitherRegNo_Code) {
      endorsementDetails = {
        newEngineNo: data?.changedData.find((item) => item.fieldName === 'propRisksEngineNumber')?.newValue,
        newChassisNo: data?.changedData.find((item) => item.fieldName === 'propRisksChassisNmbr')?.newValue,
        isBhSeries: data?.changedData.find((item) => item.fieldName === 'propRisksExtraBoolean14')?.newValue === "True" ? true : false,
        RegsistartionNo1: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.newValue,
        RegsistartionNo2: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.newValue,
        RegsistartionNo3: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.newValue,
        RegsistartionNo4: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.newValue,
        Zone: data?.changedData.find((item) => item.fieldName === 'rtoCodeAndZone')?.newValue,
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.ExtensionofGeographicalArea_Code) {
      endorsementDetails = {
        GeographicalExtension: data?.changedData.find((item) => item.fieldName === 'geographicalExtension')?.newValue,
        PropRisks_Bangladesh: data?.changedData.find((item) => item.fieldName === 'propRisksBangladesh')?.newValue,
        PropRisks_Maldives: data?.changedData.find((item) => item.fieldName === 'propRisksMaldives')?.newValue,
        PropRisks_Pakistan: data?.changedData.find((item) => item.fieldName === 'propRisksPakistan')?.newValue,
        PropRisks_Bhutan: data?.changedData.find((item) => item.fieldName === 'propRisksBhutan')?.newValue,
        PropRisks_Nepal: data?.changedData.find((item) => item.fieldName === 'propRisksNepal')?.newValue,
        PropRisks_Srilanka: data?.changedData.find((item) => item.fieldName === 'propRisksSrilanka')?.newValue,
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.InclusionofelectricalOrNonElectrical_Code) {
      endorsementDetails = {
        electricalAccessories: data?.electricalAccessories,
        nonElectricalAccessories: data?.nonElectricalAccessories,
        oldElectricalAccessories: data?.oldElectricalAccessories,
        oldNonElectricalAccessories: data?.oldNonElectricalAccessories
      };
    } else if (this.endorsementService._enCode === this.policyConstant?.Manufacturingyearonly_Code) {
      endorsementDetails = {
        yearOfManufacture: data?.changedData.find((item) => item.fieldName === 'yearOfManufacture')?.newValue,
      };
    }
    // If the endorsement type is not recognized, return generic old values
    endorsementDetails = {
      ...endorsementDetails,
      oldFirstValue: data?.changedData[0]?.oldValue,
      oldLastValue: data?.changedData[1]?.oldValue,
      oldAddress1: data?.changedData.find((item) => item.fieldName === 'address1')?.oldValue,
      oldAddress2: data?.changedData.find((item) => item.fieldName === 'address2')?.oldValue,
      oldCity: data?.changedData.find((item) => item.fieldName === 'city')?.oldValue,
      oldState: data?.changedData.find((item) => item.fieldName === 'state')?.oldValue,
      oldPincode: data?.changedData.find((item) => item.fieldName === 'pincode')?.oldValue,
      oldEmailId: data?.changedData.find((item) => item.fieldName === 'emailId')?.oldValue,
      oldMobileNumber: data?.changedData.find((item) => item.fieldName === 'mobileNo')?.oldValue,
      oldnomineeFirstName: data?.changedData.find((item) => item.fieldName === 'nomineeFirstName')?.oldValue,
      oldnomineeMiddleName: data?.changedData.find((item) => item.fieldName === 'nomineeMiddleName')?.oldValue,
      oldnomineeLastName: data?.changedData.find((item) => item.fieldName === 'nomineeLastName')?.oldValue,
      oldRelationship: data?.changedData.find((item) => item.fieldName === 'nomineeRelationShip')?.oldValue,
      oldIsMinor: data?.changedData.find((item) => item.fieldName === 'isMinor')?.oldValue == 'yes' ? 'yes' : 'no',
      oldRepresentativeFirstName: data?.changedData.find((item) => item.fieldName === 'representativeFirstName')?.oldValue,
      oldRepresentativeMiddleName: data?.changedData.find((item) => item.fieldName === 'representativeMiddleName')?.oldValue,
      oldRepresentativeLastName: data?.changedData.find((item) => item.fieldName === 'representativeLastName')?.oldValue,
      oldRelationshipWithMinor: data?.changedData.find((item) => item.fieldName === 'representativeRelationShip')?.oldValue,
      oldOtherRelationship: data?.changedData.find((item) => item.fieldName === 'otherRelationship')?.oldValue,
      oldRelationshipWiththeInsured: data?.changedData.find((item) => item.fieldName === 'relationshipWiththeInsured')?.oldValue,
      oldFinancierNames: data?.changedData.find((item) => item.fieldName === 'financierName')?.oldValue,
      oldFinancierAddresss: data?.changedData.find((item) => item.fieldName === 'financierAddress')?.oldValue,
      oldAggrementType: data?.changedData.find((item) => item.fieldName === 'financierType')?.oldValue,
      oldfirstName: data?.changedData.find((item) => item.fieldName === 'firstName')?.oldValue,
      oldlastName: data?.changedData.find((item) => item.fieldName === 'lastName')?.oldValue,
      olddateOfBirth: data?.changedData.find((item) => item.fieldName === 'dateOfBirth')?.oldValue,
      oldPanNo: data?.changedData.find((item) => item.fieldName === 'panNumber')?.oldValue,
      oldgender: data?.changedData.find((item) => item.fieldName === 'gender')?.oldValue,
      oldemailId: data?.changedData.find((item) => item.fieldName === 'emailId')?.oldValue,
      oldmobileNo: data?.changedData.find((item) => item.fieldName === 'mobileNo')?.oldValue,
      oldnomineeIsMinor: ['true', 'yes'].includes(data?.changedData.find((item) => item.fieldName === 'nomineeIsMinor')?.oldValue?.toLowerCase()) ? 'yes' : ['false', 'no'].includes(data?.changedData.find((item) => item.fieldName === 'nomineeIsMinor')?.oldValue?.toLowerCase()) ? 'no' : '',
      // oldnomineeIsMinor: data?.changedData.find((item) => item.fieldName === 'oldnomineeIsMinor')?.oldValue === 'yes'
      //   ? 'yes'
      //   : data?.changedData.find((item) => item.fieldName === 'oldnomineeIsMinor')?.oldValue === 'no'
      //     ? 'no'
      //     : '',
      oldmailingAddress: data?.changedData.find((item) => item.fieldName === 'mailingAddress')?.oldValue,
      oldmailingPinCode: data?.changedData.find((item) => item.fieldName === 'mailingPinCode')?.oldValue,
      olddiscountAmount: data?.changedData.find((item) => item.fieldName === 'discountAmount')?.oldValue,
      olddiscountRate: data?.changedData.find((item) => item.fieldName === 'discountRate')?.oldValue,
      oldIsPreviousClaim: data?.changedData.find((item) => item.fieldName === 'PropPreviousPolicyDetails_NoOfClaims')?.oldValue,
      oldNCBasperpolicy: data?.changedData.find((item) => item.fieldName === 'ncbAsPerPolicy')?.oldValue,
      oldODdiscount: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDis')?.oldValue,
      oldZone: data?.changedData.find((item) => item.fieldName === 'rtoCodeAndZone')?.oldValue,
      oldRegsistartionNo1: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.oldValue,
      oldRegsistartionNo2: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.oldValue,
      oldRegsistartionNo3: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.oldValue,
      oldRegsistartionNo4: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.oldValue,
      oldIsBhSeries: data?.changedData.find((item) => item.fieldName === 'propRisksExtraBoolean14')?.oldValue,
      oldRegsistartionNo: data?.changedData.find((item) => item.fieldName === 'propRisksRegNum1')?.oldValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum2')?.oldValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum3')?.oldValue + '-' + data?.changedData.find((item) => item.fieldName === 'propRisksRegNum4')?.oldValue,
      oldCorrectionofZone: data?.changedData.find((item) => item.fieldName === 'Zone')?.oldValue,
      oldCorrectionofRegsistartionNo: data?.changedData.find((item) => item.fieldName === 'RegsistartionNo')?.oldValue,
      oldPreviousNcbPercentage: data?.changedData.find((item) => item.fieldName === 'previousNcbPercentage')?.oldValue,
      oldPropRisks_DetariffODDis: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDis')?.oldValue,
      newPropRisks_DetariffODDis: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDis')?.newValue,
      oldPropRisks_DetariffODDisY2: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDisY2')?.oldValue,
      oldPropRisks_DetariffODDisY3: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDisY3')?.oldValue,
      oldPropRisks_DetariffODDisYr4: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDisYr4')?.oldValue,
      oldPropRisks_DetariffODDisYr5: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODDisYr5')?.oldValue,
      oldPropRisks_DetariffODLoad: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODLoad')?.oldValue,
      oldPropRisks_DetariffODLoadY2: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODLoadY2')?.oldValue,
      oldPropRisks_DetariffODLoadY3: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODLoadY3')?.oldValue,
      oldPropRisks_DetariffODLoadY4: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODLoadY4')?.oldValue,
      oldPropRisks_DetariffODLoadY5: data?.changedData.find((item) => item.fieldName === 'PropRisks_DetariffODLoadY5')?.oldValue,
      oldImt23Coverage: data?.changedData.find((item) => item.fieldName === 'propRisksCoverForLampTyres')?.oldValue.toLowerCase() === "true" ? 'Yes' : 'No',
      oldImt47Coverage: data?.changedData.find((item) => item.fieldName === 'propRisksIsVehiUsAsAToOfTra')?.oldValue.toLowerCase() === "true" ? 'Yes' : 'No',
      oldEngineNo: data?.changedData.find((item) => item.fieldName === 'propRisksEngineNumber')?.oldValue,
      oldChassisNo: data?.changedData.find((item) => item.fieldName === 'propRisksChassisNmbr')?.oldValue,
      oldGeographicalExtension: data?.changedData.find((item) => item.fieldName === 'geographicalExtension')?.oldValue.toLowerCase() === "true" ? 'Yes' : 'No',
      oldPropRisks_Bangladesh: data?.changedData.find((item) => item.fieldName === 'propRisksBangladesh')?.oldValue,
      oldPropRisks_Maldives: data?.changedData.find((item) => item.fieldName === 'propRisksMaldives')?.oldValue,
      oldPropRisks_Pakistan: data?.changedData.find((item) => item.fieldName === 'propRisksPakistan')?.oldValue,
      oldPropRisks_Bhutan: data?.changedData.find((item) => item.fieldName === 'propRisksBhutan')?.oldValue,
      oldPropRisks_Nepal: data?.changedData.find((item) => item.fieldName === 'propRisksNepal')?.oldValue,
      oldPropRisks_Srilanka: data?.changedData.find((item) => item.fieldName === 'propRisksSrilanka')?.oldValue,
      oldMailingState: data?.changedData.find((item) => item.fieldName === 'mailingState')?.oldValue,
      oldMailingDistrict: data?.changedData.find((item) => item.fieldName === 'mailingDistrict')?.oldValue,
      oldYearOfManufacture: data?.changedData.find((item) => item.fieldName === 'yearOfManufacture')?.oldValue,
    };
    if (this.endorsementService._enCode === this.policyConstant.TransferofInsurance_Code) {
      endorsementDetails = {
        ...endorsementDetails,
        oldOtherRepresentativeRelationShip: data?.changedData.find((item) => item.fieldName === 'otherRepresentativeRelationship')?.oldValue
      }
    }
    else {
      endorsementDetails = {
        ...endorsementDetails,
        oldOtherRepresentativeRelationShip: data?.changedData.find((item) => item.fieldName === 'otherRepresentativeRelationShip')?.oldValue
      }
    }

    //console.log(endorsementDetails, 'endorsementDetails');
    return endorsementDetails;
  }

  getNations(details: any): string {
    if (!details) return '';
    const nations = [];
    if (details.PropRisks_Bangladesh && details.PropRisks_Maldives && details.PropRisks_Pakistan && details.PropRisks_Bhutan && details.PropRisks_Nepal && details.PropRisks_Srilanka) {
      if (details.PropRisks_Bangladesh.toLowerCase() === 'true') nations.push('Bangladesh');
      if (details.PropRisks_Maldives.toLowerCase() === 'true') nations.push('Maldives');
      if (details.PropRisks_Pakistan.toLowerCase() === 'true') nations.push('Pakistan');
      if (details.PropRisks_Bhutan.toLowerCase() === 'true') nations.push('Bhutan');
      if (details.PropRisks_Nepal.toLowerCase() === 'true') nations.push('Nepal');
      if (details.PropRisks_Srilanka.toLowerCase() === 'true') nations.push('Srilanka');
    }
    return nations.length > 0 ? nations.join(', ') : '';
  }

  getOldNations(details: any): string {
    if (!details) return '';
    const nations = [];
    if (details.oldPropRisks_Bangladesh && details.oldPropRisks_Maldives && details.oldPropRisks_Pakistan && details.oldPropRisks_Bhutan && details.oldPropRisks_Nepal && details.oldPropRisks_Srilanka) {
      if (details.oldPropRisks_Bangladesh.toLowerCase() === 'true') nations.push('Bangladesh');
      if (details.oldPropRisks_Maldives.toLowerCase() === 'true') nations.push('Maldives');
      if (details.oldPropRisks_Pakistan.toLowerCase() === 'true') nations.push('Pakistan');
      if (details.oldPropRisks_Bhutan.toLowerCase() === 'true') nations.push('Bhutan');
      if (details.oldPropRisks_Nepal.toLowerCase() === 'true') nations.push('Nepal');
      if (details.oldPropRisks_Srilanka.toLowerCase() === 'true') nations.push('Srilanka');
    }
    return nations.length > 0 ? nations.join(', ') : '';
  }

}
